import { getLogoUrl, getLogoWidth } from './logos'

export default {
  name: 'Logo',
  computed: {
    icon() {
      return getLogoUrl(this.lang)
    },
    width() {
      return getLogoWidth(this.lang)
    },
    lang() {
      return this.$store.app.context.app.i18n.locale
    },
  },
}
